<template>
	<label class="flex gap-2 items-center justify-between">
		<div v-if="slots.default && slotPosition === 'before'" class="-mt-1">
			<slot />
		</div>

		<span
			class="relative block rounded-full select-none h-8 w-14 transition-colors duration-300 bg-white ring ring-neutral-100"
		>
			<input
				type="checkbox"
				:checked="modelValue"
				class="peer appearance-none inset-0 absolute size-full cursor-pointer z-10"
				@change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
			/>
			<span
				class="pointer-events-none absolute top-1 left-1 size-6 p-1 rounded-full shadow flex items-center justify-center transition-all duration-300 translate-x-0 opacity-100 peer-checked:translate-x-6 peer-checked:opacity-0 bg-neutral-500 text-white"
			>
				<CrossIcon class="size-2" />
			</span>
			<span
				class="pointer-events-none absolute top-1 left-1 size-6 p-1 rounded-full shadow flex items-center justify-center transition-all duration-300 translate-x-0 opacity-0 peer-checked:translate-x-6 peer-checked:opacity-100 bg-green-500 text-white"
			>
				<CheckIcon class="size-3" />
			</span>
		</span>

		<div v-if="slots.default && slotPosition === 'after'" class="-mt-1">
			<slot />
		</div>
	</label>
</template>

<script lang="ts" setup>
import CheckIcon from '@thermenresorts/icons/svg/check.svg';
import CrossIcon from '@thermenresorts/icons/svg/cross.svg';

withDefaults(defineProps<{
	modelValue?: boolean
	slotPosition?: 'before' | 'after'
}>(), {
	modelValue: false,
	slotPosition: 'after',
});

const slots = defineSlots();

const emit = defineEmits(['update:modelValue']);
</script>
